import { AxiosError, AxiosResponse } from "axios";
import { IGetListRequest, IResponse, IServerError } from "../models/common";

import { IWireTransfer } from "../models/WireTransfer";
import http from "../common/http-commons";

export const WireTransferService = {
  getWireTransfer: async (
    clientId: string,
    data: IGetListRequest,
    navigateToLogout: (path: string) => void,
  ): Promise<any | IServerError | IResponse> => {
    // const RQFixedResponse: any = {
    // 	page: 1,
    // 	size: 25,
    // 	total: 2,
    // 	items: [
    // 		{
    // 			clientId: "6a0b02877fd71cc0b1b4c547",
    // 			confirmationNo: "13",
    // 			id: "6a0d5cd35072589be23ba6af",
    // 			date: "Jan 03, 2026",
    // 			wireAmount: "22,000.00",
    // 			wireMethod: "Invoice",
    // 			creditAmount: "302.00",
    // 			debitAmount: null,
    // 			accumulated: null,
    // 			approvedStatus: "No",
    // 		},
    // 		{
    // 			clientId: "6a0b02877fd71cc0b1b4c547",
    // 			confirmationNo: "11",
    // 			id: "6a0d5a385072589be23ba69e",
    // 			date: "Jan 01, 2026",
    // 			wireAmount: "25,000.00",
    // 			wireMethod: "Bank",
    // 			creditAmount: null,
    // 			debitAmount: null,
    // 			accumulated: null,
    // 			approvedStatus: "No",
    // 		},
    // 		{
    // 			clientId: "6a0b02877fd71cc0b1b4c547",
    // 			confirmationNo: "11",
    // 			id: "6a0d5a385072589bw23ba69e",
    // 			date: "Jan 01, 2026",
    // 			wireAmount: "25,000.00",
    // 			wireMethod: "Bank",
    // 			creditAmount: null,
    // 			debitAmount: null,
    // 			accumulated: null,
    // 			approvedStatus: "No",
    // 		},
    // 		{
    // 			clientId: "6a0b02877fd71cc0b1b4c547",
    // 			confirmationNo: "11",
    // 			id: "6a0d5a385072589be22ba69e",
    // 			date: "Jan 01, 2026",
    // 			wireAmount: "25,000.00",
    // 			wireMethod: "Bank",
    // 			creditAmount: null,
    // 			debitAmount: null,
    // 			accumulated: null,
    // 			approvedStatus: "No",
    // 		},
    // 	],
    // 	keyField: [
    // 		{
    // 			field: "id",
    // 			templateUrl: "/payroll-wire-transfer/details/id",
    // 		},
    // 	],
    // 	headerColumns: [
    // 		{
    // 			field: "label",
    // 			headerName: "Type",
    // 			description: "",
    // 			flex: 1,
    // 			hide: false,
    // 			hideable: false,
    // 			sortable: false,
    // 			sortingOrder: "asc",
    // 			resizable: false,
    // 			type: "string",
    // 			align: "left",
    // 			headerAlign: "left",
    // 			hideSortIcons: false,
    // 			disableColumnMenu: true,
    // 			disableReorder: true,
    // 			disableExport: true,
    // 			maskable: false,
    // 			isFixed: true,
    // 			isEditable: true,
    // 			sequence: 0,
    // 			frozenColumn: false,
    // 			footer: null,
    // 			minWidth: null,
    // 			maxWidth: null,
    // 			fieldName: null,
    // 			edr: "edr",
    // 		},
    // 		{
    // 			field: "date",
    // 			headerName: "Date",
    // 			description: "",
    // 			flex: 1,
    // 			hide: false,
    // 			hideable: false,
    // 			sortable: true,
    // 			sortingOrder: "asc",
    // 			resizable: false,
    // 			type: "string",
    // 			align: "center",
    // 			headerAlign: "left",
    // 			hideSortIcons: false,
    // 			disableColumnMenu: true,
    // 			disableReorder: true,
    // 			disableExport: true,
    // 			maskable: false,
    // 			isFixed: true,
    // 			isEditable: true,
    // 			sequence: 1,
    // 			frozenColumn: false,
    // 			footer: null,
    // 			minWidth: null,
    // 			maxWidth: null,
    // 			fieldName: null,
    // 			edr: "edr",
    // 		},
    // 		{
    // 			field: "confirmationNo",
    // 			headerName: "Conf no.",
    // 			description: "",
    // 			flex: 1,
    // 			hide: false,
    // 			hideable: false,
    // 			sortable: false,
    // 			sortingOrder: "asc",
    // 			resizable: false,
    // 			type: "string",
    // 			align: "left",
    // 			headerAlign: "left",
    // 			hideSortIcons: false,
    // 			disableColumnMenu: true,
    // 			disableReorder: true,
    // 			disableExport: true,
    // 			maskable: false,
    // 			isFixed: true,
    // 			isEditable: true,
    // 			sequence: 2,
    // 			frozenColumn: false,
    // 			footer: null,
    // 			minWidth: null,
    // 			maxWidth: null,
    // 			fieldName: null,
    // 			edr: "edr",
    // 		},
    // 		{
    // 			field: "wireAmount",
    // 			headerName: "Amount",
    // 			description: "",
    // 			flex: 1,
    // 			hide: false,
    // 			hideable: false,
    // 			sortable: false,
    // 			sortingOrder: "asc",
    // 			resizable: false,
    // 			type: "string",
    // 			align: "right",
    // 			headerAlign: "left",
    // 			hideSortIcons: false,
    // 			disableColumnMenu: true,
    // 			disableReorder: true,
    // 			disableExport: true,
    // 			maskable: false,
    // 			isFixed: true,
    // 			isEditable: true,
    // 			sequence: 3,
    // 			frozenColumn: false,
    // 			footer: null,
    // 			minWidth: null,
    // 			maxWidth: null,
    // 			fieldName: null,
    // 			edr: "edr",
    // 		},
    // 		{
    // 			field: "creditAmount",
    // 			headerName: "Credit Amount",
    // 			description: "",
    // 			flex: 1,
    // 			hide: false,
    // 			hideable: false,
    // 			sortable: false,
    // 			sortingOrder: "asc",
    // 			resizable: false,
    // 			type: "string",
    // 			align: "right",
    // 			headerAlign: "left",
    // 			hideSortIcons: false,
    // 			disableColumnMenu: true,
    // 			disableReorder: true,
    // 			disableExport: true,
    // 			maskable: false,
    // 			isFixed: true,
    // 			isEditable: true,
    // 			sequence: 4,
    // 			frozenColumn: false,
    // 			footer: null,
    // 			minWidth: null,
    // 			maxWidth: null,
    // 			fieldName: null,
    // 			edr: "edr",
    // 		},
    // 		{
    // 			field: "debitAmount",
    // 			headerName: "Debit Amount",
    // 			description: "",
    // 			flex: 1,
    // 			hide: false,
    // 			hideable: false,
    // 			sortable: false,
    // 			sortingOrder: "asc",
    // 			resizable: false,
    // 			type: "string",
    // 			align: "right",
    // 			headerAlign: "left",
    // 			hideSortIcons: false,
    // 			disableColumnMenu: true,
    // 			disableReorder: true,
    // 			disableExport: true,
    // 			maskable: false,
    // 			isFixed: true,
    // 			isEditable: true,
    // 			sequence: 5,
    // 			frozenColumn: false,
    // 			footer: null,
    // 			minWidth: null,
    // 			maxWidth: null,
    // 			fieldName: null,
    // 			edr: "edr",
    // 		},
    // 		{
    // 			field: "accumulated",
    // 			headerName: "Accumulated",
    // 			description: "",
    // 			flex: 1,
    // 			hide: false,
    // 			hideable: false,
    // 			sortable: false,
    // 			sortingOrder: "asc",
    // 			resizable: false,
    // 			type: "string",
    // 			align: "right",
    // 			headerAlign: "left",
    // 			hideSortIcons: false,
    // 			disableColumnMenu: true,
    // 			disableReorder: true,
    // 			disableExport: true,
    // 			maskable: false,
    // 			isFixed: true,
    // 			isEditable: true,
    // 			sequence: 6,
    // 			frozenColumn: false,
    // 			footer: null,
    // 			minWidth: null,
    // 			maxWidth: null,
    // 			fieldName: null,
    // 			edr: "edr",
    // 		},
    // 		{
    // 			field: "approvedStatus",
    // 			headerName: "Approved",
    // 			description: "",
    // 			flex: 1,
    // 			hide: false,
    // 			hideable: false,
    // 			sortable: false,
    // 			sortingOrder: "asc",
    // 			resizable: false,
    // 			type: "string",
    // 			align: "left",
    // 			headerAlign: "left",
    // 			hideSortIcons: false,
    // 			disableColumnMenu: true,
    // 			disableReorder: true,
    // 			disableExport: true,
    // 			maskable: false,
    // 			isFixed: true,
    // 			isEditable: true,
    // 			sequence: 7,
    // 			frozenColumn: false,
    // 			footer: null,
    // 			minWidth: null,
    // 			maxWidth: null,
    // 			fieldName: null,
    // 			edr: "edr",
    // 		},
    // 	],
    // };
    // return new Promise((resolve) =>
    // 	setTimeout(() => resolve(RQFixedResponse), 1000),
    // );

    try {
      const response: AxiosResponse<any> = await http.get<any>(
        "/v1/payroll-wire-transfer/?client_id=" +
          clientId +
          "&order_by=" +
          data.order_by +
          "&order_direction=" +
          data.order_direction +
          "&page=" +
          data.page +
          "&size=" +
          data.size +
          "&search_query=" +
          data.search_query,
      );

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 400) {
        return {
          status: false,
          message: "Bad Request.",
          error: true,
        };
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  getById: async (
    clientId: string,
    id: string | undefined,
    navigateToLogout: (path: string) => void,
  ): Promise<IWireTransfer | IServerError | IResponse | null | any> => {
    if (!id) return null;
    try {
      const response: AxiosResponse<IWireTransfer> =
        await http.get<IWireTransfer>(`/v1/payroll-wire-transfer/${id}/`);

      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  create: async (
    requestPayload: any,
  ): Promise<IWireTransfer | IServerError | IResponse | any> => {
    if (requestPayload.id) {
      try {
        const response: AxiosResponse<IWireTransfer> =
          await http.put<IWireTransfer>(
            `/v1/payroll-wire-transfer/${requestPayload.id}/`,
            requestPayload,
          );

        if (response.status === 200) {
          return response;
        } else if (response.status === 400) {
          return response.data;
        } else if (response.status === 500) {
          return {
            status: false,
            message: "Something went wrong.",
            error: true,
          };
        }
      } catch (error) {
        const axiosError = error as AxiosError;
        console.error("An error occurred:", axiosError);
        const errorMessage =
          axiosError.response && typeof axiosError.response.data === "string"
            ? axiosError.response.data
            : "Unknown error";
        if (axiosError && axiosError.status === 401) {
          requestPayload.navigateToLogout("/logout");
          return {
            status: false,
            message: "UnAuthrized",
          };
        } else {
          return {
            status: false,
            message: errorMessage,
          };
        }
      }
    }

    try {
      const response: AxiosResponse<IWireTransfer> =
        await http.post<IWireTransfer>(
          `/v1/payroll-wire-transfer/`,
          requestPayload,
        );

      if (response.status === 201) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 401) {
        // window.location.href = '/logout';
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  update: async (
    requestPayload: any,
  ): Promise<IWireTransfer | IServerError | IResponse | any> => {
    try {
      const response: AxiosResponse<IWireTransfer> =
        await http.put<IWireTransfer>(
          `/v1/payroll-wire-transfer/bulk/update/`,
          requestPayload,
        );

      if (response.status === 200) {
        return response;
      } else if (response.status === 400) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delWireTransfer: async (
    delPayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.delete<string>(
        `/v1/payroll-wire-transfer/${delPayload.wireTransferId}/`,
      );

      if (response.status === 204) {
        return "Wire Transfer has been deleted successfully";
      } else if (response.status === 200) {
        return "Wire Transfer has been deleted successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        delPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
  delBulkWireTransfer: async (
    requestPayload: any,
  ): Promise<string | IServerError | IResponse> => {
    try {
      const response = await http.delete<string>(`/v1/wire-Transfer/`, {
        data: requestPayload.wireTransferId,
      });
      if (response.status === 200) {
        return response.data;
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        requestPayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },

  archiveWireTransfer: async (
    archivePayload: any,
  ): Promise<string | IServerError | IResponse | any> => {
    // return new Promise(resolve => setTimeout(() => resolve("Flex Field has been deleted successfully"), 1000));
    try {
      const response: AxiosResponse<string> = await http.post<string>(
        `/v1/payroll-wire-transfer/${archivePayload.wireTransferId}/`,
      );

      if (response.status === 201) {
        return "WireTransfer has been archived successfully";
      } else if (response.status === 200) {
        return "WireTransfer has been archived successfully";
      } else if (response.status === 500) {
        return {
          status: false,
          message: "Something went wrong.",
          error: true,
        };
      }

      return {
        status: false,
        message: "Something went wrong please try again later.",
      };
    } catch (error) {
      const axiosError = error as AxiosError;
      console.error("An error occurred:", axiosError);
      const errorMessage =
        axiosError.response && typeof axiosError.response.data === "string"
          ? axiosError.response.data
          : "Unknown error";
      if (axiosError && axiosError.status === 401) {
        archivePayload.navigateToLogout("/logout");
        return {
          status: false,
          message: "UnAuthrized",
        };
      } else {
        return {
          status: false,
          message: errorMessage,
        };
      }
    }
  },
};
